<template>
  <div class="superprize">
    <div class="superprize__info">
      <div class="info__canvas">
        <canvas id="confeti" class="active"></canvas>
      </div>
      <div class="info__image">
        <img :src="image" />
      </div>
      <div class="info__title" v-html="title"></div>
      <div class="info__subtitle" v-html="subtitle"></div>
    </div>
    <div class="superprize__action">
      <Button 
        variant="secondary"
        size="lg"
        mobile
        :text="buttonText"
        @click="onAction"
      />
    </div>
    <div class="superprize__backgound">
      <div class="info__title" v-html="title"></div>
      <div class="info__subtitle" v-html="subtitle"></div>
      <div class="superprize__action">
        <Button 
          variant="secondary"
          size="lg"
          mobile
          :text="buttonText"
          @click="onAction"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@rr-component-library/button/src/main';
import ConfettiEffect from './confetti';

export default {
  name: 'Superprize',
  designVersion: '1.0.0',
  components: {
    Button,
  },
  props: {
    /**
     * Изображение
     */
    image: {
      type: String,
    },
    /**
     * Текст заголовка
     */
    title: {
      type: String,
    },
    /**
     * Текст подзаголовка
     */
    subtitle: {
      type: String,
    },
    /**
     * Текст на кнопке
     */
    buttonText: {
      type: String,
    },
    /**
     * Действие по нажатию на кнопку
     */
    buttonAction: {
      type: Object,
    },
  },
  data() {
    return {
      effect: null,
    };
  },
  methods: {
    onAction() {
      if (!this.buttonAction) return;
      if (this.buttonAction.link) location.href = this.buttonAction.link;
      else if (this.buttonAction.action) this.buttonAction.action();
    },
  },
  mounted() {
    setTimeout(() => { this.effect = new ConfettiEffect(); }, 1000);
  },
};
</script>

<style lang="scss" scoped>
  @import "./Superprize";
</style>
